// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IChannelDto
 */
export interface IChannelDto {
    /**
     * 
     * @type {string}
     * @memberof IChannelDto
     */
    type?: IChannelDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IChannelDto
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IChannelDto
     */
    is_default?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IChannelDtoTypeEnum {
    EMAIL = 'EMAIL',
    SMS = 'SMS'
}


/**
 * Check if a given object implements the IChannelDto interface.
 */
export function instanceOfIChannelDto(value: object): value is IChannelDto {
    return true;
}

export function IChannelDtoFromJSON(json: any): IChannelDto {
    return IChannelDtoFromJSONTyped(json, false);
}

export function IChannelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IChannelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'] == null ? undefined : json['value'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
    };
}

export function IChannelDtoToJSON(json: any): IChannelDto {
    return IChannelDtoToJSONTyped(json, false);
}

export function IChannelDtoToJSONTyped(value?: IChannelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
        'is_default': value['is_default'],
    };
}

